export default __webpack_public_path__ + "static/mobile-banner-fe90e2025aca5cdac3e45422388943fa.png";